a.auth = (function(){
	var my = {
		authorize:function(){
			$.ajax({
				type:'POST',
				url:'/api/auth/',
				data:{
					token:localStorage.getItem('token')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (!result.success) {
						my.loginWin();
					}
					else {
						// Check if a valid account has been chosen
						if (localStorage.getItem('accountname') && localStorage.getItem('aid')) {
							// Check validity
						}
						else {
							my.selectAccountWin({
								close:function(){
									a.loader.fs.create();
									location.reload();
								},
								disable_back:true,
								slideFrom:'fromtop'
							});
						}
					}
				}
			});
		},
		loginWin:function(){
			tpl.run({
				tpl:'/tpl/auth/login.ejs?v='+v,
				data:{},
				cb:function(c){
					var token = a.popup.create({
						slideFrom:'fromtop',
						content:c,
						disable_topbar:true,
						css_class:'login',
						ready:function(token){
							my.initLoginWin(token);
						}
					});
				}
			});
		},
		initLoginWin:function(token){
			var win = $('#popupid_'+token);
			// Sign in click
			$('button[data-action="signin"]',win).unbind('click').click(function(){
				var btntxt = $(this).text();
				$(this).prop('disabled',true).html('<i class="fa fa-sync fa-spin"></i>');
				var username = $('input[name="username"]',win).val();
				var password = $('input[name="password"]',win).val();
				$.ajax({
					type:'POST',
					url:'/api/auth/signin/',
					data:{
						usr:username,
						pwd:password
					},
					dataType:'json',
					cache: false,
					success:function(result) {
						if (result.success) {
							localStorage.setItem('firstname',result.userinfo.firstname);
							localStorage.setItem('lastname',result.userinfo.lastname);
							localStorage.setItem('name',result.userinfo.name);
							localStorage.setItem('username',result.userinfo.username);
							localStorage.setItem('token',result.token);
							my.selectAccountWin({
								close:function(){
									a.loader.fs.create();
									location.reload();
								},
								disable_back:true,
								slideFrom:'fromtop'
							});
							setTimeout(function(){
								a.popup.remove(token,function(){
									$('.msg',win).empty();
								});
							},200);
						}
						else {
							$('.msg',win).empty().append('Wrong username/password');
						}
					}
				}).done(function(){
					$(this).prop('disabled',false).text(btntxt);
					setTimeout(function(){
						$('.msg',win).empty();
					},3000);
				});
			});
			$('a[data-action="forgotpw"]',win).unbind('click').click(function(){
				my.forgotPasswordWin(function(){
					
				});
			});
		},
		signOut:function(){
			my.loginWin();
			localStorage.clear();
			$.ajax({
				type:'POST',
				url:'/api/auth/signout/',
				data:{
					token:localStorage.getItem('token')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					//
				}
			}).done(function(){
				location.hash='/';
			});
		},
		selectAccountWin:function(o){
			var cb_close = o.close || function(){};
			var disable_back = o.disable_back || false;
			var slideFrom = o.slideFrom || 'fromtop';
			var cb_ready = o.ready || function(token){};
			tpl.run({
				tpl:'/tpl/auth/selectaccount/page.ejs?v='+v,
				data:{},
				cb:function(c){
					var token = a.popup.create({
						slideFrom:slideFrom,
						content:c,
						disable_topbar:false,
						title:'Select account',
						disable_back:disable_back,
						ready:function(token){
							var win = $('#popupid_'+token);
							a.loader.area.create($('div[data-area="accountlist"]',win));
							cb_ready(token);
							$.ajax({
								type:'GET',
								url:'/api/myaccount/account/list/',
								data:{
									token:localStorage.getItem('token')
								},
								dataType:'json',
								cache: false,
								success:function(result) {
									tpl.run({tpl:'/tpl/auth/selectaccount/list.ejs?v='+v,data:result,cb:function(c){
										$('div[data-area="accountlist"]',win).empty().append(c);
										$('ul>li',win).unbind('click').click(function(i,e){
											var sel = result.list[$(this).index()];
											localStorage.setItem('accountname',sel.accountname);
											localStorage.setItem('aid',sel.aid);
											localStorage.setItem('account-viewname',sel.viewname);
											localStorage.setItem('perm_interface_web',sel.perm_interface_web);
											localStorage.setItem('perm_interface_app',sel.perm_interface_app);
											localStorage.setItem('perm_content_item',sel.perm_content_item);
											localStorage.setItem('perm_content_qr',sel.perm_content_qr);
											localStorage.setItem('perm_content_type',sel.perm_content_type);
											localStorage.setItem('perm_content_filter',sel.perm_content_filter);
											localStorage.setItem('perm_content_location',sel.perm_content_location);
											localStorage.setItem('perm_content_contact',sel.perm_content_contact);
											localStorage.setItem('perm_action_usage',sel.perm_action_usage);
											localStorage.setItem('perm_action_reservation',sel.perm_action_reservation);
											localStorage.setItem('perm_action_location',sel.perm_action_location);
											localStorage.setItem('perm_action_condition',sel.perm_action_condition);
											localStorage.setItem('perm_action_event',sel.perm_action_event);
											localStorage.setItem('perm_action_issue',sel.perm_action_issue);
											localStorage.setItem('perm_action_inventory',sel.perm_action_inventory);
											localStorage.setItem('perm_administration_users',sel.perm_administration_users);
											localStorage.setItem('perm_administration_account',sel.perm_administration_account);
											localStorage.setItem('perm_administration_subscription',sel.perm_administration_subscription);
											$.ajax({
												type:'POST',
												url:'/api/myaccount/account_selected/',
												data:{
													token:localStorage.getItem('token'),
													accountname:sel.accountname
												},
												dataType:'json',
												cache: false,
												success:function(result) {}
											}).done(function(){});
											a.popup.remove(token,function(){
												cb_close();
											});
										});
									}});
								}
							});
						}
					});
				}
			});
		},
		forgotPasswordWin:function(cb_close){
			tpl.run({
				tpl:'/tpl/auth/forgotpassword.ejs?v='+v,
				data:{},
				cb:function(c){
					var token = a.popup.create({
						slideFrom:'fromleft',
						title:'Forgot password',
						content:c,
						ready:function(token){
							
						}
					});
				}
			});
		}
	}
	return my;
}());